"use client"

import * as amplitude from "@amplitude/analytics-browser"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import dynamic from "next/dynamic"
import { useEffect } from "react"
import { ApplicationEnvironmentMolecule } from "../env/store"

// Dynamically import the blockchain tracker to avoid SSR bundling issues
const BlockchainTracker = dynamic(
  () =>
    import("./amplitude-blockchain-tracker").then(
      (mod) => mod.BlockchainTracker,
    ),
  { ssr: false },
)

// hello world
export const Amplitude = reatomComponent(() => {
  const { amplitudeApiKey, amplitudeServerUrl, buildVersion } = useMolecule(
    ApplicationEnvironmentMolecule,
  )

  useEffect(() => {
    if (!amplitudeApiKey) return

    amplitude.init(amplitudeApiKey, {
      serverZone: "EU",
      fetchRemoteConfig: true,
      autocapture: {
        elementInteractions: true,
      },
      appVersion: buildVersion,
      serverUrl: amplitudeServerUrl,
    })
  }, [amplitudeApiKey, amplitudeServerUrl, buildVersion])

  return <BlockchainTracker />
}, "Amplitude")

export function useContextEnrichmentPlugin<T extends Record<string, unknown>>(
  pluginName: string,
  context: T,
) {
  useEffect(() => {
    amplitude.add({
      name: pluginName,
      type: "enrichment",
      execute: async (event) => {
        event.event_properties = {
          ...event.event_properties,
          ...context,
        }

        return event
      },
    })

    return () => {
      amplitude.remove(pluginName)
    }
  }, [context, pluginName])
}
